// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"1e4c33ca","477":"686603fc","484":"64ad1ac4","556":"90e4ff25","711":"f8ed1942"}[chunkId] + ".chunk.js";
};